import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SEO from '@/components/common/SEO';
import Spinner from '@/components/common/Spinner';
import { useAuth } from '@/contexts/AuthContext';

const NotFoundPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Spinner size="lg" color="text-accent-yellow" />
      </div>
    );
  }

  const primaryHref = isAuthenticated ? '/home' : '/contests';
  const primaryLabel = isAuthenticated ? 'Go Home' : 'Explore Contests';

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(primaryHref, { replace: true });
  };

  return (
    <>
      <SEO
        title="Page Not Found | Fantasy Futbol"
        description="The Fantasy Futbol page you requested could not be found."
        path={location.pathname}
        noindex
      />
      <main className="flex min-h-[calc(100vh-190px)] items-center justify-center px-4 py-10 text-center">
        <section className="w-full max-w-md rounded-xl border border-gray-700/70 bg-primary-dark p-7 shadow-lg shadow-black/20 sm:p-9">
          <p className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-accent-yellow">
            404
          </p>
          <h1 className="mt-2 text-balance font-heading text-2xl font-bold text-white sm:text-3xl">
            Page not found
          </h1>
          <p className="mt-3 text-pretty text-sm leading-6 text-gray-400">
            That address may be incomplete, expired, or moved.
          </p>
          <div className="mt-7 grid gap-3 sm:grid-cols-2">
            <Link to={primaryHref} className="btn-primary flex min-h-11 items-center justify-center px-5">
              {primaryLabel}
            </Link>
            <button type="button" onClick={goBack} className="btn-outline min-h-11 px-5">
              Go Back
            </button>
          </div>
        </section>
      </main>
    </>
  );
};

export default NotFoundPage;
